import {AuthenticationGateway} from '../domain/authentication.gateway';
import {TMyTerms} from '../domain/termsOfUseAndPrivacyPolicies.entities';
export class MyTermsOfUseAndPrivacyPoliciesUseCase {
    constructor(private gate: AuthenticationGateway) {}

    async execute(): Promise<TMyTerms | undefined> {
        return this.gate.myTermsOfUseAndPrivacyPolicies();
    }
}
